// Series — curated groupings a piece can belong to.
export enum Series {
    DisassembledIdentity = 'DISASSEMBLED_IDENTITY',
    TableForTwo = 'TABLE_FOR_TWO',
    BoxedIn = 'BOXED_IN',
    LiminalPresence = 'LIMINAL_PRESENCE',
}

export const SERIES_DISPLAY: Record<Series, string> = {
    [Series.DisassembledIdentity]: 'Disassembled Identity',
    [Series.TableForTwo]: 'Table for Two',
    [Series.BoxedIn]: 'Boxed In',
    [Series.LiminalPresence]: 'Liminal Presence',
};
